window.addEventListener('load', event => {
    const autoplayVideos = document.querySelectorAll('video');
    const docBody = document.body;

    const playVideo = function() {
        for (let video of autoplayVideos) {
            video.play();
        }
        docBody.removeEventListener('touchstart', playVideo);
    };

    if (window.matchMedia('(max-width:640px)').matches && autoplayVideos.length) {
        docBody.addEventListener('touchstart', playVideo);
    }
});
